import { render, staticRenderFns } from "./CardsCollection.vue?vue&type=template&id=bffb870a&"
import script from "./CardsCollection.vue?vue&type=script&lang=js&"
export * from "./CardsCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports